// PROD-2743 design sheet v1.1 §1 Identity (D-27, A14): person first; MRN quiet, once, last.
import type { PatientDatum } from '@/types/patient-api';
/**
 * The identity fact line for the switch-ON picker (design sheet §1 Identity, D-27 / A14): age · sex
 * first, then (in search results) DOB and phone so a clinician can tell two people apart, and the
 * MRN once, LAST. Age is the server-computed string (it already handles infants in months/days);
 * DOB is shown in the format the server sent (date formats are unchanged tonight). Missing parts
 * are dropped rather than rendered as dashes.
 */
export function identityFacts(
  p: Pick<PatientDatum, 'age' | 'gender' | 'dob' | 'phone' | 'contactNumber' | 'mrn'>,
  { includeContact }: { includeContact: boolean },
): string {
  const parts = [
    p.age?.trim() || null,
    p.gender?.name?.trim() || null,
    includeContact ? p.dob?.trim() || null : null,
    includeContact ? (p.phone ?? p.contactNumber)?.trim() || null : null,
    p.mrn?.trim() || null,
  ].filter((v): v is string => Boolean(v));
  return parts.length > 0 ? parts.join(' · ') : 'No MRN';
}
